import { Component, Input } from '@angular/core';
import { IDynamicallyCreatedComponent } from '../../core-data-model/DynamicallyCreated.component';
import { Util } from '../../core-utilities/Util';
import { TranslationService } from '../../translations';

export class CopyToClipboardButtonConfig {
    labelText?: string;
    iconClass?: string;
    onClick?: Function;
    tooltipKey?: string;
    buttonClass?: string;
    textToCopy: string;
}

@Component({
    selector: 'pi-copy-to-clipboard-button',
    template: `
        <div
            (click)="copyToClipboard()"
            [ngClass]="properties.buttonClass"
            tooltip
            [tooltipContent]="TR.key(properties.tooltipKey)"
            [tooltipDisabled]="!properties.tooltipKey"
            [tooltipAnimation]="true"
            tooltipPlacement="top"
        >
            @if (properties.iconClass) {
                <span [ngClass]="[getIconTypeClass(), properties.iconClass]">
                </span>
            }
            @if (properties.labelText) {
                <span>
                    {{ properties.labelText }}
                </span>
            }
        </div>
        <div
            class="copiedMessage"
            [ngClass]="{
                displayMessage: showCopyMessage
            }"
        >
            <i class="ico-moon ico-moon-checkmark4"></i> {{ TR.key('Copied') }}
        </div>
    `,
    standalone: false
})
export class CopyToClipboardButtonComponent
    implements IDynamicallyCreatedComponent
{
    @Input()
    properties: CopyToClipboardButtonConfig;
    showCopyMessage = false;
    private timeOut: number;

    constructor(
        public TR: TranslationService,
        public util: Util
    ) {}

    getIconTypeClass(): string {
        return this.properties.iconClass.includes('ico-moon')
            ? 'ico-moon'
            : 'fa';
    }

    copyToClipboard() {
        this.showCopyMessage = true;
        this.util.copyStringToClipboard(this.properties.textToCopy);
        if (this.timeOut) {
            clearTimeout(this.timeOut);
        }
        this.timeOut = window.setTimeout(
            () => (this.showCopyMessage = false),
            1500
        );
    }
}
